import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import RsLoaderCircular from '@Pages/RetroSynthesis/components/RsLoader/RsLoaderCircular';

function RoutesLoaderInQueue({ type, queuePosition }) {
  return (
    <>
      <RsLoaderCircular
        className={cn(
          'project-status-grid-item__routes-loader',
          'project-status-grid-item__routes-loader--in-queue',
          `project-status-grid-item__routes-loader--${type}`
        )}
        position={queuePosition}
      />
      <span className="project-status-grid-item__routes-loader-label">In queue</span>
    </>
  );
}

RoutesLoaderInQueue.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  queuePosition: PropTypes.string,
};

export default RoutesLoaderInQueue;
